import React from 'react'
import { GetStaticProps } from 'next'
import { useTranslations } from 'next-intl'
import { NextSeo } from 'next-seo'
import dynamic from 'next/dynamic'

import Header from '../../components/layouts/header'
import { TableConverter } from '@/components/table'

// 动态导入文档组件
const MarkdownTableDoc = dynamic(() => import('../../docs/markdown-table.mdx'), {
  ssr: false,
  loading: () => <p>加载文档中...</p>
})

function CsvToMarkdownPage() {
  const t = useTranslations('MarkdownTable')

  return (
    <div className="min-h-screen">
      <NextSeo
        title={`CSV 转 Markdown 表格工具 - ${t('pageTitle')}`}
        description="在线 CSV 转 Markdown 表格工具，快速将 CSV 数据转换为 Markdown 表格格式，支持复制和下载。"
        canonical="https://devtool.tech/table/csv-to-markdown"
        openGraph={{
          url: 'https://devtool.tech/table/csv-to-markdown',
          title: `CSV 转 Markdown 表格工具 - ${t('pageTitle')}`,
          description: "在线 CSV 转 Markdown 表格工具，快速将 CSV 数据转换为 Markdown 表格格式，支持复制和下载。",
        }}
      />
      <Header title="CSV 转 Markdown 表格" />
      <div className="container mx-auto px-4 py-8">
      
      <TableConverter
        defaultInputFormat="csv"
        defaultOutputFormat="markdown"
      />
      
      <MarkdownTableDoc />
          </div>
    </div>
  )
}

export default CsvToMarkdownPage

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default
    }
  }
} 